import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import TextWinds from '../../../components/common/TextWinds';
import ClassGroupAddCard from '../../../components/lms/class-group/ClassGroupAddCard';
import ClassGroupListCard from '../../../components/lms/class-group/ClassGroupListCard';
import { LmsClassGroupType } from '../../../constants/types/lms-type';
import { getClassGroupList } from '../../../api/utils/lms/class-group/api';
import LmsGuideButton from '../../../components/lms/LmsGuideButton';
import { LmsLinkItemKey } from '../../../constants/types/lms/type';

/** LMS > 학생 관리 > 반 관리 */
const ClassGroupMgmt = () => {
  const { classId } = useParams<{ classId: string }>();

  const [classGroups, setClassGroups] = useState<LmsClassGroupType[]>();
  const [loadFailed, setLoadFailed] = useState(false);

  const reloadClassGroups = () => {
    setLoadFailed(false);
    getClassGroupList(classId)
      .then((res) => setClassGroups(res.result))
      .catch((err) => {
        console.error(err);
        setLoadFailed(true);
      });
  };

  useEffect(() => {
    reloadClassGroups();
  }, [classId]);

  return (
    // PC 에서는 페이지 자체가 스크롤되지 않도록 높이를 화면(헤더 60px 제외)에 맞추고,
    // 넘치는 부분은 아래 반 목록 안에서만 스크롤되게 한다.
    <div className="flex w-full flex-col pt-4 xl:h-[calc(100vh-60px)] xl:overflow-hidden xl:px-5 xl:pt-6">
      <header className="flex flex-col gap-3 px-5 xl:flex-row xl:items-start xl:justify-between xl:px-0">
        <div className="min-w-0">
          <TextWinds type="title_h2" xlType="title_h3" className="mb-[2px]">
            반 관리
          </TextWinds>
          <TextWinds type="content_body3">
            새로운 반을 만들고, 기존 반을 수정하거나 삭제할 수 있어요.
          </TextWinds>
        </div>

        <LmsGuideButton itemKey={LmsLinkItemKey.CLASS_GROUP_MANAGE} />
      </header>

      {/* 반 추가 / 반 수정·삭제 카드를 PC 에서 좌우로 배치한다. */}
      <div className="mt-5 flex min-h-0 flex-1 flex-col gap-5 pb-5 xl:mt-6 xl:flex-row xl:items-start xl:gap-6 xl:pb-6">
        <ClassGroupAddCard
          classId={classId}
          classGroups={classGroups}
          reloadClassGroups={reloadClassGroups}
        />
        <ClassGroupListCard
          classId={classId}
          classGroups={classGroups}
          loadFailed={loadFailed}
          reloadClassGroups={reloadClassGroups}
        />
      </div>
    </div>
  );
};

export default ClassGroupMgmt;
